import { render } from "./Logo.vue?vue&type=template&id=39fe958c&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=39fe958c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fe958c"]])

export default __exports__